<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <!-- <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">添加企业</el-button>
          </div> -->
        </zv-table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service";
export default {
  name: "businessManagement",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.controlListG,
        query: {

        },
        columns: [
          {
            title: "企业状态",
            key: "type_name",
            minWidth:"100",
          },
          {
            title: "用户数量",
            minWidth:"150",
            showTooltip: true,
            key: "company_count"
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth:"150",
            showTooltip: true,
             render(h, ctx) {
              return h("span", ctx.row.last_admin_username + '--' + vm.$commFunc.formatDate(ctx.row.last_admin_time));
            }
          },
          {
            title: "用户权限",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doSetting.bind(this, ctx.row.type)
                  }
                },
                "权限设置"
              );

              let arr = [];
              arr.push(editBtn);

              return h("span", arr);
            }
          }
        ]
      },
    };
  },

  computed: {

  },

  methods: {
    doSetting(ids) {
      this.$router.push({
        name: "permissionSettings-G",
        query: {id: ids}
      })
    }
  },

  // created() {
  //   this.$api.getRoleList().then(res => {
  //     this.roleListData = res.data
  //   })

  //   this.$api.getRightCodeList().then(res => {
  //     this.rightCodeListData = res.data
  //   })
  // },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
